import { PropertyTypes, PropertyUsages } from "@eave/shared/types/api";

const dollarFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const dollarsTo2Places = (d: number): string => (d === 0 ? "$0" : dollarFormatter.format(d));

export const propertyUsageToDisplay: { [key in PropertyUsages]: string | string[] } = {
  [PropertyUsages.primary]: PropertyUsages.primary,
  [PropertyUsages.secondary]: PropertyUsages.secondary,
  [PropertyUsages.investment]: PropertyUsages.investment,
  [PropertyUsages.neither]: PropertyUsages.neither,
};

export const propertyTypeToDisplay: { [key in PropertyTypes]: string | string[] } = {
  [PropertyTypes.SFR]: PropertyTypes.SFR,
  [PropertyTypes.SFRATT]: PropertyTypes.SFRATT,
  [PropertyTypes.PUD]: PropertyTypes.PUD,
  [PropertyTypes.PUDATT]: PropertyTypes.PUDATT,
  [PropertyTypes.SiteCondo]: PropertyTypes.SiteCondo,
  [PropertyTypes.LowRiseCondo]: PropertyTypes.LowRiseCondo,
  [PropertyTypes.MidRiseCondo]: PropertyTypes.MidRiseCondo,
  [PropertyTypes.HighRiseCondo]: PropertyTypes.HighRiseCondo,
  [PropertyTypes.Duplex]: PropertyTypes.Duplex,
  [PropertyTypes.DuplexATT]: PropertyTypes.DuplexATT,
  [PropertyTypes.Triplex]: PropertyTypes.Triplex,
  [PropertyTypes.TriplexATT]: PropertyTypes.TriplexATT,
  [PropertyTypes.Quadplex]: PropertyTypes.Quadplex,
  [PropertyTypes.QuadplexATT]: PropertyTypes.QuadplexATT,
};
